import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import { TYPOGRAPHY_18 } from 'theme/theme'
import HelpText from 'components/forms/helpText'

const Label = styled.label`
  ${TYPOGRAPHY_18}

  display: flex;
  color: ${props => props.value ? '#505259' : '#A0A5B3'};
  margin-bottom: 10px;
`

const LabelComponent = ({ label, id, helpText }) => {
  return (
    <Label htmlFor={id} data-test={`label-${id}`}>
      { label }
      { helpText ? <HelpText helpText={helpText} name={id} /> : null }
    </Label>
  )
}

export default LabelComponent

LabelComponent.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  helpText: PropTypes.any
}
